import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcHandHoldingUsd, IcInfo, IcListAlt, IcCheckCircle } from "../../Icons";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Label,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function AbonosCreate() {
  const { user } = useContext(AuthContext);
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ABONOS   = process.env.REACT_APP_URL_ABONOS;
  const URL_CARGOS   = process.env.REACT_APP_URL_CARGOS;

  const hoy = moment(new Date()).format("YYYY-MM-DD");

  const [clientes,              setClientes]              = useState([]);
  const [selectedCliente,       setSelectedCliente]       = useState("");
  const [selectedClienteNombre, setSelectedClienteNombre] = useState("");
  const [fecha,                 setFecha]                 = useState(hoy);
  const [formaPago,             setFormaPago]             = useState("Efectivo");
  const [value,                 setValue]                 = useState("");
  const [concepto,              setConcepto]              = useState("Abono");
  const [total,                 setTotal]                 = useState(0);
  const [inputFields,           setInputFields]           = useState([]);
  const [modalProgreso,         setModalProgreso]         = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  // ── Datos ────────────────────────────────────────────────────────────────────
  useMemo(() => {
    axios
      .get(URL_CLIENTES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        setClientes(res.data.filter((c) => c.is_active === "Si" && (c.saldo || 0) > 0));
      })
      .catch(() => {});

    if (!selectedCliente) return;

    axios
      .get(`${URL_CARGOS}/cliente/${selectedCliente}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const fields = res.data.map((a) => ({
          id:            a._id,
          fecha:         a.fecha,
          total_general: a.importe,
          saldo:         a.saldo,
          abonos:        a.abonos,
          nota:          a.idCargo,
          importe:       0,
          clientes:      a.clientes[0]._id,
          observaciones: "NA",
          movimiento:    "Nota",
        }));
        setInputFields(fields);
        setTotal(0);
      })
      .catch(() => {});
  }, [selectedCliente]);

  // ── Handlers ─────────────────────────────────────────────────────────────────
  const handleChangeInputImporte = (id, e) => {
    const newFields = inputFields.map((i) => {
      if (id === i.id) {
        const val = parseFloat(e.target.value);
        if (e.target.value === "" || val <= i.saldo) {
          return { ...i, importe: parseFloat(e.target.value) || 0 };
        } else {
          Swal.fire({ icon: "error", title: "Oops...", text: "El Pago excede el Saldo" });
        }
      }
      return i;
    });
    setInputFields(newFields);
    setTotal(newFields.reduce((t, i) => t + (i.importe || 0), 0));
  };

  const handleChangeInput = (id, e) => {
    setInputFields(inputFields.map((i) =>
      id === i.id ? { ...i, [e.target.name]: e.target.value } : i
    ));
  };

  function savePago() {
    const conImporte = inputFields.filter((a) => a.importe > 0);
    if (!conImporte.length) {
      Swal.fire({ icon: "warning", title: "Sin importes", text: "Ingresa al menos un importe" });
      return;
    }
    Swal.fire({
      title: "¿Estás seguro?",
      text:  "Se registrará el abono",
      icon:  "warning",
      showCancelButton:   true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor:  "#d33",
      confirmButtonText:  "Sí, registrar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      toggleProgreso();
      let pending = conImporte.length;
      conImporte.forEach((a) => {
        axios
          .post(URL_ABONOS, {
            fecha,
            importe:        a.importe,
            clientes:       selectedCliente,
            cargos:         a.id,
            formaPago,
            concepto,
            comisionPagada: "No",
            observaciones:  a.observaciones,
            aplicado:       "No",
          }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
          .then(() => {
            axios.patch(`${URL_CARGOS}/${a.id}`,
              { saldo: a.saldo - a.importe, abonos: a.abonos + a.importe },
              { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
            );
            pending -= 1;
            if (pending === 0) {
              Swal.fire("¡Listo!", "Abono registrado con éxito", "success");
              setTimeout(() => window.location.reload(), 1000);
            }
          })
          .catch(() => Swal.fire({ icon: "error", title: "Error", text: "Something went wrong!" }));
      });
    });
  }

  const options = clientes.map((c) => ({
    firstLetter: /[0-9]/.test(c.nombre_comercial[0].toUpperCase()) ? "0-9" : c.nombre_comercial[0].toUpperCase(),
    ...c,
    junta: c.nombre_comercial,
  }));

  // ── Render ────────────────────────────────────────────────────────────────────
  return (
    <>
      <Header />
      <br />
      {user.menu_usuarios ? (
        <div className="card container col-sm-11">

          {/* ── Page header ──────────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcHandHoldingUsd style={{ marginRight: 8, color: "#10b981" }} />
                Capturar Pago
              </h3>
              <p className="page-subtitle">Registra abonos a los cargos pendientes del cliente</p>
            </div>
          </div>

          <Form>
            {/* ── Sección 1: Información general ───────────────────────── */}
            <div className="form-section">
              <div className="form-section-header">
                <IcInfo />
                <span className="form-section-title">Información General</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={2}>
                    <FormGroup>
                      <Label>Fecha</Label>
                      <Input
                        type="date"
                        value={fecha}
                        onChange={(e) => setFecha(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Cliente</Label>
                      <Autocomplete
                        size="small"
                        value={value}
                        onChange={(_, sel) => {
                          if (!sel) return;
                          setValue(sel);
                          setSelectedCliente(sel._id);
                          setSelectedClienteNombre(sel.nombre_comercial);
                        }}
                        options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                        groupBy={(o) => o.firstLetter}
                        getOptionLabel={(o) => o.junta}
                        renderInput={(params) => (
                          <TextField {...params} label="Selecciona" variant="outlined" />
                        )}
                        renderOption={(o) => (
                          <React.Fragment>
                            {o.codigo} {o.nombre_comercial}
                          </React.Fragment>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={2}>
                    <FormGroup>
                      <Label>Concepto</Label>
                      <Input
                        type="select"
                        value={concepto}
                        onChange={(e) => setConcepto(e.target.value)}
                      >
                        <option value="Abono">Abono</option>
                        <option value="Bonificacion">Bonificación</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={2}>
                    <FormGroup>
                      <Label>Forma de Pago</Label>
                      <Input
                        type="select"
                        value={formaPago}
                        onChange={(e) => setFormaPago(e.target.value)}
                      >
                        <option value="Efectivo">Efectivo</option>
                        <option value="Transfer">Transfer</option>
                        <option value="TDC">TDC</option>
                        <option value="Bonificacion">Bonificación</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>

            {/* ── Sección 2: Notas pendientes ───────────────────────────── */}
            {inputFields.length > 0 && (
              <div className="form-section">
                <div className="form-section-header dark">
                  <IcListAlt />
                  <span className="form-section-title">
                    Notas Pendientes
                    {selectedClienteNombre && (
                      <span style={{ fontWeight: 400, textTransform: "none", letterSpacing: 0, marginLeft: 8, opacity: 0.75 }}>
                        — {selectedClienteNombre}
                      </span>
                    )}
                  </span>
                </div>
                <div style={{ overflowX: "auto" }}>
                  <Table className="table-dark-header" striped borderless size="sm" style={{ marginBottom: 0 }}>
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Movimiento</th>
                        <th>Nota</th>
                        <th>Total</th>
                        <th>Abonos</th>
                        <th>Saldo</th>
                        <th>Importe a Pagar</th>
                        <th>Observaciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inputFields.map((a) => (
                        <tr key={a.id}>
                          <td>{a.fecha}</td>
                          <td>{a.movimiento}</td>
                          <td><strong>{a.nota}</strong></td>
                          <td>{"$" + new Intl.NumberFormat("en-US").format(a.total_general)}</td>
                          <td>{"$" + new Intl.NumberFormat("en-US").format(a.abonos)}</td>
                          <td>
                            <Badge color={a.saldo > 0 ? "danger" : "success"} className="badge-pill">
                              {"$" + new Intl.NumberFormat("en-US").format(a.saldo)}
                            </Badge>
                          </td>
                          <td style={{ minWidth: 110 }}>
                            <Input
                              type="number"
                              name="importe"
                              value={a.importe}
                              onChange={(e) => handleChangeInputImporte(a.id, e)}
                              style={{ borderColor: a.importe > 0 ? "#10b981" : undefined }}
                            />
                          </td>
                          <td style={{ minWidth: 140 }}>
                            <Input
                              type="text"
                              name="observaciones"
                              value={a.observaciones}
                              onChange={(e) => handleChangeInput(a.id, e)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}

            {/* ── Barra de total + acción ───────────────────────────────── */}
            <div className="total-bar">
              <span>Total del Pago</span>
              <Badge color="danger" className="BadgeSize badge-pill">
                {"$" + new Intl.NumberFormat("en-US").format(total)}
              </Badge>
            </div>

            <div className="submit-bar">
              <Button
                color="success"
                disabled={total === 0}
                onClick={savePago}
              >
                <IcCheckCircle style={{ marginRight: 6 }} />
                Registrar Pago
              </Button>
            </div>
          </Form>

          {/* ── Modal progreso ────────────────────────────────────────── */}
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Procesando…</h4>
            </ModalHeader>
            <ModalBody className="text-center py-4">
              <p style={{ color: "#64748b", fontSize: "0.82rem", marginBottom: 16 }}>
                Registrando abonos, por favor espera.
              </p>
              <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
                {[0, 1, 2].map((i) => (
                  <Spinner key={i} style={{ width: "2rem", height: "2rem", color: "#0f172a" }} />
                ))}
              </div>
            </ModalBody>
          </Modal>

        </div>
      ) : undefined}
    </>
  );
}

export default AbonosCreate;
